import type { InternalRefetchQueriesInclude } from '@apollo/client';
import { QSetExportFormModal } from '@exam-management/qset-export';
import { Box, IconButton, Menu, MoreVertIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { type MouseEvent, useState } from 'react';

import { ExportQSetActionMenu } from '../export-qset-action-menu';

interface QSetReviewSubtaskActionMenuProps {
  taskId: string;
  qSetId: string;
  dueDate: Date | null;
  refetchQueries?: InternalRefetchQueriesInclude;
}

export default function QSetReviewSubtaskActionMenu(
  props: Readonly<QSetReviewSubtaskActionMenuProps>,
) {
  const { qSetId, taskId } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [isQSetExportModalOpen, { open: openQSetExportModal, close: closeQSetExportModal }] =
    useDisclosure();

  const isOpen = anchorEl !== null;

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportQSetAction = () => {
    openQSetExportModal();
    handleClose();
  };

  return (
    <>
      <IconButton
        sx={(theme) => ({
          border: `1px solid ${theme.palette.grey[400]}`,
          borderRadius: theme.shape.rounded(1),
        })}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        sx={(theme) => ({
          mt: theme.spacing(1),
          '.MuiPaper-root': { minWidth: '180px' },
          '.MuiList-root': {
            p: theme.spacing(0),
          },
        })}
      >
        <Box sx={(theme) => ({ p: theme.spacing(2) })}>
          <ExportQSetActionMenu onClick={handleExportQSetAction} />
        </Box>
      </Menu>
      <QSetExportFormModal
        qSetId={qSetId}
        taskId={taskId}
        open={isQSetExportModalOpen}
        onClose={closeQSetExportModal}
      />
    </>
  );
}
